import dayjs from "dayjs";
import z from "zod";

/**
 * RequisicaoCompraSchema
 */

export const RequisicaoCompraSchema = z.object({
  status: z.coerce.string().transform(s => Number(s)).default("0"),
  aprovadoPor: z.coerce.number().nullable().default(null),
  dataAprovadoPor: z.coerce.date().nullable().default(null),
  nro: z.coerce.number().optional(),
  dataCadastro: z.coerce.date(),
  solicitante: z.coerce.number(),
  dataRequisicao: z.coerce.date().optional(),
  centroCusto: z.coerce.number(),
  dataPrevistaUtilizacao: z.coerce.date().optional(),
  descricao: z.string().nullable().default(null),
  observacao: z.string().nullable().default(null),
  arquivo1: z.instanceof(File).optional(),
  limparArquivo1: z.boolean().default(false),
  arquivo2: z.instanceof(File).optional(),
  limparArquivo2: z.boolean().default(false),
}).superRefine((data, ctx) => {
  if (data.status === 1 || data.status === 3) {
    if (data.aprovadoPor === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['aprovadoPor'],
        message: 'Este campo deve ser preenchido!',
      });
    }
    if (data.dataAprovadoPor === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['dataAprovadoPor'],
        message: 'Este campo deve ser preenchido!',
      });
    }
  }
});

/**
 * RequisicaoCompraForm
 */

export type RequisicaoCompraForm = z.infer<typeof RequisicaoCompraSchema>;

/**
 * initialRequisicaoCompraForm
 */

export const initialRequisicaoCompraForm = (): Partial<RequisicaoCompraForm> => ({
  status: 0,
  dataCadastro: dayjs().startOf('day').toDate(),
  aprovadoPor: null,
  dataAprovadoPor: null,
  descricao: null,
  observacao: null,
  limparArquivo1: false,
  limparArquivo2: false,
});